import t, { useRef as f } from "react";
import { Link as p } from "../../../../../Link/Link.js";
import v from "../../../../utils/links.js";
import { ChevronRight as _ } from "@olxbr/ds-icons";
import { sendClickEvent as b } from "../../../../utils/sendClickEvent.js";
import { NewBadge as h } from "./components/NewBadge/index.js";
const g = _ref => {
  let {
    accountInfo: r,
    hasNavbar: o,
    openSubMenu: l,
    enableNewBadge: n
  } = _ref;
  const {
      publicAccountId: i,
      isLogged: m,
      isAutosPro: c
    } = r,
    s = f(null),
    d = v({
      publicAccountId: i,
      menuPro: !0
    }),
    a = e => {
      b(e, "sub_menu", {
        login: m,
        isAutosPro: c,
        menuPro: !0,
        hasNavbar: !!o
      });
    };
  return t.createElement(t.Fragment, null, d.map((e, u) => t.createElement("li", {
    key: "fly-out-item-".concat(e.title),
    "data-open": l,
    "data-divider": e.divider,
    className: "olx-header__overflow-item",
    "data-testid": "overflow-content-lazy"
  }, t.createElement(p, {
    href: e.href,
    tabIndex: l ? 0 : -1,
    className: "olx-header__overflow-link",
    ref: u === 0 ? s : null,
    onClick: () => a(e.objectDetail),
    onAuxClick: () => a(e.objectDetail)
  }, t.createElement(e.Icon, {
    size: "16"
  }), t.createElement("span", {
    className: "olx-header__overflow-link-text"
  }, e.title), e.badge && n && t.createElement(h, null), o && t.createElement(_, {
    className: "olx-header__overflow-pro-icon"
  })))));
};
export { g as OverflowContent };